import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {OrgChartModule} from 'ng-org-chart';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TreeModule} from 'ng2-tree';
import {TreeviewModule} from 'ngx-treeview';
import {HttpModule} from '@angular/http';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DataTableModule} from 'angular2-datatable';
import {NgMaterialMultilevelMenuModule} from 'ng-material-multilevel-menu';
import {IvyCarouselModule} from 'angular-responsive-carousel';
// import {NG2DataTableModule} from 'angular2-datatable-pagination';
import {Loggedin, PlatformCentralAuth} from './authFilter/platformCentralAuth';
import {
    FilterPipe,
    OrderByPipe,
    FilterPipe1,
    SearchFile,
    SearchByObject,
    FilterByObject,
    FilterByName,
    FilterByQuery,
    YouTubeURLFilter,
    urlYouTubeFilter, urlDataAnalyticsFilter, FilterExecutorsPipe
} from './filter.pipe';
import {routing} from './app-routing.module';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import {ChartsModule} from 'ng2-charts';
import {RecaptchaModule} from 'ng-recaptcha';
import {NgBpmnEditorModule} from 'ng-bpmn';
import {AddNewPermissionComponent} from './permission-groups/permission-groups.component';
import {DialogComponent} from './shared/dialog/dialog.component';
import {AddNewCloudComponent} from './settings/cloud-platform-settings/cloud-platform-settings.component';
import {AddNewGatewayComponent} from './settings/api-gateway-settings/api-gateway-settings.component';
import {CreateFolderDialog} from './file-store/file-store.component';
import {UploadFileDialog} from './file-store/file-store.component';
import {UploadFolderDialog} from './file-store/file-store.component';

import {
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatExpansionPanel
} from '@angular/material';
import {Angular2CsvModule} from 'angular2-csv';
import {NgJsonEditorModule} from 'ang-jsoneditor';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {HeaderComponent, SupportHeaderComponent} from './header/header.component';
import {
    filterNames,
    LeftpanelComponent,
    filterByName,
    filterNames1,
    PromotionConfirmationComponent,
    DeleteConfirmationComponent, ApplicationDeleteConfirmationComponent, BillingWarningDialog
} from './leftpanel/leftpanel.component';
import {FeedbackComponent, FooterComponent, LegalComponent, FaqComponent} from './footer/footer.component';
import {ApiComponent} from './api/api.component';
import {ConnecttocrudService} from './connecttocrud.service';
import {AddComponent} from './api/add/add.component';
import {EditComponent} from './api/edit/edit.component';
import {ConfirmReplaceRecordComponent} from './api/edit/edit.component';
import {CustomOperationEditComponent} from './customoperation/edit/custom-operation-edit.component';
import {InfoComponent} from './api/info/info.component';
import {VariablesDialog} from './bpmn/bpmn.component';
import {ImportComponent} from './api/import/import.component';
import {CrudapiComponent, AttributeDescriptionComponent} from './crudapi/crudapi.component';
import {LoginpanelComponent} from './loginpanel/loginpanel.component';
import {
    CreateDatabaseComponent,
    DialogOverviewExampleDialogComponent,
    PartnerOnboardComponent
} from './partner-onboard/partner-onboard.component';
import {HomeOldComponent, ContactSalesComponent} from './home-old/home-old.component';
import {PlansComponent} from './plans/plans.component';
import {
    EndpointComponent,
    MetricsComponent,
    ManageEntitiesComponent,
    PublishServiceConfirmationComponent, ActivateServiceConfirmationComponent, SecureApiConfirmationComponent
} from './manage-entities/manage-entities.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {EditEntityComponent, EntityVersionChangeConfirmationComponent} from './edit-entity/edit-entity.component';
import {FileStoreComponent} from './file-store/file-store.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {LegalDocsComponent} from './legal-docs/legal-docs.component';
import {AddAttributeComponent, CreateApiComponent, QueryBuilderComponent} from './query-builder/query-builder.component';
import {QueryBuilderModule} from 'angular2-query-builder';
import {CustomoperationComponent} from './customoperation/customoperation.component';
import {EditorComponent} from './query-builder/editor/editor.component';
import {CommonDataApiComponent} from './common-data-api/common-data-api.component';
import {MetricsDashboardComponent} from './metrics-dashboard/metrics-dashboard.component';
import {DigitalTransformerComponent} from './digital-transformer/digital-transformer.component';
import {
    DevexComponent,
    DeployAsApiComponent, DefaultApiUrlComponent
} from './devex/devex.component';
import {ConfirmationWithoutResponseAttributesComponent} from './devex/devex.component';
import {ApimanagementComponent} from './apimanagement/apimanagement.component';
import {ManageRolesComponent} from './manage-roles/manage-roles.component';
import {PermissionGroupsComponent} from './permission-groups/permission-groups.component';
import {UserManagementComponent} from './user-management/user-management.component';
import {FabricatorComponent} from './fabricator/fabricator.component';
import {ResponseMapComponent} from './fabricator/response-map/response-map.component';
import {ResourceJsonEditorComponent} from './devex/json-editor/resource-json-editor.component';
import {RuleSetComponent} from './fabricator/rule-set/rule-set.component';
import {ApiExecutorComponent} from './devex/api/executor/api-executor.component';
import {
    HeadersComponent,
    NewMockResponseEntryInputComponent,
    ReplaceMockDataConfirmationComponent
} from './devex/headers/headers.component';
import {TestComponent} from './devex/headers/test/test.component';
import {AuthServiceConfig, GoogleLoginProvider} from 'angular4-social-login';
import {UniqueComponent} from './unique.component';
import {ViewDialogComponent} from './api-new/api-new.component';
import {EditDialogComponent} from './api-new/api-new.component';
import {AddCatComponent} from './settings/category/category.component';
import {AddDialogComponent} from './api-new/api-new.component';
import {AddToCollComponent} from './settings/collections/collections.component';
import {DeleteDialogComponent} from './api-new/api-new.component';
import {AddEnvComponent} from './settings/environment-settings/environment-settings.component';
import {CreatefromopenapiComponent} from './createfromopenapi/createfromopenapi.component';
import {MonacoEditorModule} from 'ngx-monaco-editor';
import {SubArrayComponent} from './crudapi/sub-array/sub-array.component';
import {
    BlocklyAddButtonsComponent,
    CoreCheckComponent,
    DependencyCheckComponent,
    NewBlocklyComponent
} from './new-blockly/new-blockly.component';
import {
    ApplicationVersionChangeConfirmationComponent,
    DeploymentplanComponent,
    InjectLogsDirective
} from './deploymentplan/deploymentplan.component';
import {DatabaseviewerComponent} from './databaseviewer/databaseviewer.component';
import {ExecutorComponent} from './executor/executor.component';
import {SwifterComponent} from './swifter/swifter.component';
import {AuthorizationComponent} from './authorization/authorization.component';
import {ShowProgressComponent} from './show-progress/show-progress.component';
import {ShowResultsComponent} from './show-results/show-results.component';
import {BusinessLogicApiListComponent} from './business-logic-api-list/business-logic-api-list.component';
import {InlineEditComponent} from './devex/inline-edit/inline-edit.component';
import {AddVaultComponent} from './settings/logging-settings/logging-settings.component';
import {ApiBrowserComponent} from './testsuite/apiBrowser.component';
import {TestCaseNameInputDialog} from './testcase/testcase.component';
// @ts-ignore
import {AngularEditorModule} from '@kolkov/angular-editor';
import {WidgetLineAnimModule} from './widgets/widget-line-anim/widget-line-anim.module';
import {FooterModule} from './shared/footer/footer.module';
import {CommonContainerModule} from './shared/common-container/common-container.module';
import {TbScrollVisibilityModule} from './tb/tb-scroll-visibility/tb-scroll-visibility.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TbScrollSingleActiveModule} from './tb/tb-scroll-single-active/tb-scroll-single-active.module';
import {MaterialModule} from './material.module';
import {DashboardContainerComponent} from './container/dashboard-container/dashboard-container.component';
import {AuthContainerComponent} from './container/auth-container/auth-container.component';
import {SupportComponent} from './components/support/support.component';
import {DialogProgressComponent} from './shared/dialog/dialog-progress/dialog-progress.component';
import {DialogSuccessComponent} from './shared/dialog/dialog-success/dialog-success.component';
import {DialogErrorComponent} from './shared/dialog/dialog-error/dialog-error.component';
import {SignupComponent} from './signup/signup.component';
import {SimpleApiListComponent} from './simple-api-list/simple-api-list.component';
import {GatewayComponent} from './gateway/gateway.component';
import {BasicAuthComponent} from './gateway/Authentication/BasicAuth/BasicAuth.component';
import {KeyAuthComponent} from './gateway/Authentication/KeyAuth/KeyAuth.component';
import {OAuth2Component} from './gateway/Authentication/OAuth2/OAuth2.component';
import {HmacAuthComponent} from './gateway/Authentication/HmacAuth/HmacAuth.component';
import {JwtComponent} from './gateway/Authentication/Jwt/Jwt.component';
import {LdapAuthComponent} from './gateway/Authentication/LdapAuth/LdapAuth.component';
import {AclComponent} from './gateway/Security/Acl/Acl.component';
import {CorsComponent} from './gateway/Security/Cors/Cors.component';
import {IPRestrictionComponent} from './gateway/Security/IpRestriction/IPRestriction.component';
import {BotDetectionComponent} from './gateway/Security/BotDetection/BotDetection.component';
import {RateLimitingComponent} from './gateway/TrafficControl/RateLimiting/RateLimiting.component';
import {ResponseRateLimitingComponent} from './gateway/TrafficControl/ResponserateLimiting/ResponseRateLimiting.component';
import {RequestSizeLimitingComponent} from './gateway/TrafficControl/RequestsizeLimiting/RequestSizeLimiting.component';
import {RequestTerminationComponent} from './gateway/TrafficControl/RequestTermination/RequestTermination.component';
import {AwsLambdaComponent} from './gateway/Serverless/AwsLambda/AwsLambda.component';
import {PreFunctionComponent} from './gateway/Serverless/PreFunction/PreFunction.component';
import {PostFunctionComponent} from './gateway/Serverless/PostFunction/PostFunction.component';
import {AzureFunctionComponent} from './gateway/Serverless/AzureFunction/AzureFunction.component';
import {DataDogComponent} from './gateway/Analytics-monitoring/DataDog/DataDog.component';
import {PrometheusComponent} from './gateway/Analytics-monitoring/Prometheus/Prometheus.component';
import {ZipkinComponent} from './gateway/Analytics-monitoring/Zipkin/Zipkin.component';
import {AuthenticationComponent} from './gateway/Authentication/authentication.component';
import {PopUpComponent} from './apimanagement/apimanagement.component';
import {ConfigureInRouteComponent} from './apimanagement/apimanagement.component';
import {ApplyToRouteComponent} from './apimanagement/apimanagement.component';
import {BillingComponent, ChoosePaymentDialog, PaymentConfirmationDialog} from './billing/billing.component';
import {MasterPluginComponent} from './master-plugin/master-plugin.component';
import {TooGoodToBelieveComponent} from './components/home/home-cards/home-cards.component';
import {ImageUploadComponent} from './image-upload/image-upload.component';
import {DragDropDirective} from './image-upload/drag-drop.directive';
import {AttributesListComponent} from './attributes-list/attributes-list.component';
import {SettingsComponent} from './settings/settings.component';
import {SettingsTopComponent} from './settings/top/settings-top.component';
import {BusinessdetailsComponent} from './settings/businessdetails/businessdetails.component';
import {BusinesslocationsComponent} from './settings/businesslocations/businesslocations.component';
import {CreditsComponent} from './settings/credits/credits.component';
import {DatabasesComponent} from './settings/databases/databases.component';
import {IdentitymanagerComponent} from './settings/identitymanager/identitymanager.component';
import {IpconfigComponent} from './settings/ipconfig/ipconfig.component';
import {BrandingComponent} from './settings/branding/branding.component';
import {AccountsComponent} from './settings/accounts/accounts.component';
import {SubQueryBuilderComponent} from './query-builder-base/sub-query-builder/sub-query-builder.component';
import {QueryBuilderBaseComponent} from './query-builder-base/query-builder-base.component';
import {ResumeParserComponent} from './resume-parser/resume-parser.component';
import {BpmnComponent} from './bpmn/bpmn.component';
import {WorkfloweditorComponent} from './bpmn/workfloweditor/workfloweditor.component';
import {CamundaviewerComponent} from './bpmn/camundaviewer/camundaviewer.component';
import {ProcessInstanceComponent} from './bpmn/process-instance/process-instance.component';
import {EmailtemplatebuilderComponent} from './emailtemplatebuilder/emailtemplatebuilder.component';
import {ExecuteemailtemplateComponent} from './executeemailtemplate/executeemailtemplate.component';
import {
    DifferentiateParametersComponent,
    EditConfirmationComponent,
    SelectAPIComponent
} from './executeemailtemplate/executeemailtemplate.component';
import {CreateDatabaseDuringSignUpComponent, EditDatabaseDuringSignUpComponent} from './signup/signup.component';
import {CsvService} from './csv.service';
import {Api1ExecutorComponent, ResponseSettingsComponent} from './devex/api1/api1-executor/api1-executor.component';
import {DmnComponent} from './dmn/dmn.component';
import {CampaignManagerComponent} from './campaign-manager/campaign-manager.component';
import {ApiNewComponent} from './api-new/api-new.component';
import {FormCmpComponent} from './api-new/form-cmp/form-cmp.component';
import {EditCmpComponent} from './api-new/edit-cmp/edit-cmp.component';
import {GetStartedComponent} from './landing-page/get-started/get-started.component';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {VideoDialogComponent} from './landing-page/video-dialog/video-dialog.component';
import {ConnectorComponent} from './landing-page/connector/connector.component';
import {DetailComponent, filterCard, filterCardByName, filterCollection} from './landing-page/detail/detail.component';
import {CreatorComponent} from './landing-page/creator/creator.component';
import {EnablerComponent} from './landing-page/enabler/enabler.component';
import {TransformerComponent} from './landing-page/transformer/transformer.component';
import {ViewerComponent} from './devex/viewer/viewer.component';
import {ApiKeyComponent} from './settings/api-key/api-key.component';
import {DashboardComponent} from './settings/dashboard/dashboard.component';
import {MetricsSettingsComponent} from './settings/metrics-settings/metrics-settings.component';
import {AudienceSettingsComponent} from './settings/audience-settings/audience-settings.component';
import {AuthorizationsSettingsComponent} from './settings/authorizations-settings/authorizations-settings.component';
import {CampaignSettingsComponent} from './settings/campaign-settings/campaign-settings.component';
import {ComplianceSettingsComponent} from './settings/compliance-settings/compliance-settings.component';
import {CouponManagementSettingsComponent} from './settings/coupon-management-settings/coupon-management-settings.component';
import {ConnectorsSettingsComponent} from './settings/connectors-settings/connectors-settings.component';
import {EncryptionSettingsComponent} from './settings/encryption-settings/encryption-settings.component';
import {PermissionGroupSettingsComponent} from './settings/permission-group-settings/permission-group-settings.component';
import {RolesSettingsComponent} from './settings/roles-settings/roles-settings.component';
import {UserGroupsSettingsComponent} from './settings/user-groups-settings/user-groups-settings.component';
import {SourceControlManagementSettingsComponent} from './settings/source-control-management-settings/source-control-management-settings.component';
import {ApiRegistrarSettingsComponent} from './settings/api-registrar-settings/api-registrar-settings.component';
import {UsersSettingsComponent} from './settings/users-settings/users-settings.component';
import {GrRateLimitingSettingsComponent} from './settings/gr-rate-limiting-settings/gr-rate-limiting-settings.component';
import {CodeGenSettingsComponent} from './settings/code-gen-settings/code-gen-settings.component';
import {BotSettingsComponent} from './settings/bot-settings/bot-settings.component';
import {GtIpSettingsComponent} from './settings/gt-ip-settings/gt-ip-settings.component';
import {IntegrationLanguagesSettingsComponent} from './settings/integration-languages-settings/integration-languages-settings.component';
import {IntegratorSettingsComponent} from './settings/integrator-settings/integrator-settings.component';
import {ServicesSettingsComponent} from './settings/services-settings/services-settings.component';
import {ThemesSettingsComponent} from './settings/themes-settings/themes-settings.component';
import {ServiceProvidersSettingsComponent} from './settings/service-providers-settings/service-providers-settings.component';
import {SubscriptionSettingsComponent} from './settings/subscription-settings/subscription-settings.component';
import {TransformationApiSettingsComponent} from './settings/transformation-api-settings/transformation-api-settings.component';
import {TransformationCobolSettingsComponent} from './settings/transformation-cobol-settings/transformation-cobol-settings.component';
import {TransformationDatabaseSettingsComponent} from './settings/transformation-database-settings/transformation-database-settings.component';
import {BillingSettingsComponent} from './settings/billing-settings/billing-settings.component';
import {SecuritySettingsComponent} from './settings/security-settings/security-settings.component';
import {DevexSettingsComponent} from './settings/devex-settings/devex-settings.component';
import {CloudPlatformSettingsComponent} from './settings/cloud-platform-settings/cloud-platform-settings.component';
import {EnvironmentSettingsComponent} from './settings/environment-settings/environment-settings.component';
import {LoggingSettingsComponent} from './settings/logging-settings/logging-settings.component';
import {ApiGatewaySettingsComponent} from './settings/api-gateway-settings/api-gateway-settings.component';
import {DatabaseInfSettingsComponent} from './settings/database-inf-settings/database-inf-settings.component';
import {FileSettingsComponent} from './settings/file-settings/file-settings.component';
import {IdentitySettingsComponent} from './settings/identity-settings/identity-settings.component';
import {AddCmpComponent} from './api-new/add-cmp/add-cmp.component';
import {TrafficSettingsComponent} from './settings/traffic-settings/traffic-settings.component';
import {GtCorsSettingsComponent} from './settings/gt-cors-settings/gt-cors-settings.component';
import {EmailSettingsComponent} from './settings/email-settings/email-settings.component';
import {PermissionSettingsComponent} from './settings/permission-settings/permission-settings.component';
import {IntegrationsComponent} from './settings/integrations/integrations.component';
import {ConnectorsComponent} from './settings/connectors/connectors.component';
import {GetConnectorConfigurationsComponent} from './settings/connectors/connectors.component';
import {GetPasswordComponent} from './settings/connectors/connectors.component';
import {ShowCredentialsComponent} from './settings/connectors/connectors.component';
import {AddServiceProviderComponent} from './landing-page/detail/detail.component';
import {AddNewAuthorizationConfigurationComponent} from './settings/connectors/connectors.component';
import {CategoriesComponent} from './settings/categories/categories.component';
import {CategoryComponent} from './settings/category/category.component';
import {ProviderCategoryComponent} from './settings/provider-category/provider-category.component';
import {AddProdComponent} from './settings/provider-category/provider-category.component';
import {AddServiceProviderCategoryComponent} from './landing-page/detail/detail.component';
import {DocumentorComponent, PageVersionChangeConfirmationComponent} from './documentor/documentor.component';
import {DocComponent} from './documentor/doc/doc.component';
import {DocsComponent} from './docs/docs.component';
import {EditDocsComponent} from './edit-docs/edit-docs.component';
import {DocseditorComponent} from './docseditor/docseditor.component';
import {CollectionsComponent} from './settings/collections/collections.component';
import {CloudInfrastructureComponent} from './common-data-api/cloud-infrastructure/cloud-infrastructure.component';
import {ComputerNetworksComponent} from './common-data-api/computer-networks/computer-networks.component';
import {DatabaseComponent} from './common-data-api/database/database.component';
import {DetailCdaComponent} from './common-data-api/detail-cda/detail-cda.component';
import {EducationComponent} from './common-data-api/education/education.component';
import {GeoComponent} from './common-data-api/geo/geo.component';
import {LocalesComponent} from './common-data-api/locales/locales.component';
import {TalentManagementComponent} from './common-data-api/talent-management/talent-management.component';
import {ManageemailtemplatesComponent} from './manageemailtemplates/manageemailtemplates.component';
import {Ng2SearchPipeModule} from 'ng2-search-filter';
import {PasswordManagerComponent} from './settings/password-manager/password-manager.component';
import {CloudInfraManagerComponent} from './settings/cloud-infra-manager/cloud-infra-manager.component';
import {EnvironmentManagerComponent} from './settings/environment-manager/environment-manager.component';
import {ApigatewayManagerComponent} from './settings/apigateway-manager/apigateway-manager.component';
import {DevExServiceManagerComponent} from './settings/dev-ex-service-manager/dev-ex-service-manager.component';
import {DatabaseManagerComponent} from './settings/database-manager/database-manager.component';
import {EnvironmentCreatorComponent} from './settings/environment-manager/environment-creator/environment-creator.component';
import {AddEnvironmentComponent} from './settings/environment-settings/add-environment/add-environment.component';
import {CobolToApiComponent} from './cobol-to-api/cobol-to-api.component';
import {AceEditorModule} from 'ng2-ace-editor';
import {AddSecretComponent} from './settings/logging-settings/logging-settings.component';
import {SamplesComponent} from './samples/samples.component';
import {ResultsViewerComponent} from './new-blockly/results-viewer/results-viewer.component';
import {UxbuilderComponent} from './uxbuilder/uxbuilder.component';
import {PromotionComponent} from './promotion/promotion.component';
import {ApimenupanelComponent} from './leftpanel/apimenupanel/apimenupanel.component';
import {MatVerticalStepperScrollerDirective} from './signup/signup.component';
import {ClickOutsideDirective} from './click-outside.directive';
import {JsontoapiComponent} from './jsontoapi/jsontoapi.component';
import {ApitoapiComponent} from './apitoapi/apitoapi.component';
import {ConnectorlistComponent} from './connectorlist/connectorlist.component';
import {EnvironmentCreationComponent} from './settings/environment-manager/environment-creation/environment-creation.component';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ChatComponent, Feedback1Component} from './feedback/feedback.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ConfigurationsComponent} from './settings/configurations/configurations.component';
import {AuditLogsComponent} from './settings/audit-logs/audit-logs.component';
import {SnackbarComponent} from './snackbar/snackbar.component';
import {SwitchEnvironmentComponent} from './header-ribbon/header-ribbon.component';
import {DaasCreatorComponent} from './daas-creator/daas-creator.component';
import {ApiManagerComponent} from './api-manager/api-manager.component';
import {DataaccessapiComponent} from './dataaccessapi/dataaccessapi.component';
import {EndPointsComponent} from './end-points/end-points.component';
import {LoaderWithProgressComponent} from './leftpanel/leftpanel.component';
import {AddGatewayResourceComponent} from './leftpanel/leftpanel.component';
import {UseExistingTableConfirmationComponent} from './crudapi/crudapi.component';
import {ApiResponseSettingsComponent} from './api-response-settings/api-response-settings.component';
import {ApiCacheSettingsComponent} from './api-cache-settings/api-cache-settings.component';
import {CrudapiAdvancedComponent} from './crudapi-advanced/crudapi-advanced.component';
import {EditEntityAdvancedComponent} from './edit-entity-advanced/edit-entity-advanced.component';
import {CopyToPartnerComponent} from './leftpanel/leftpanel.component';
import {ForeignKeyConstraintsComponent} from './leftpanel/foreign-key-constraints/foreign-key-constraints.component';
import {AddForeignKeyConstraintComponent} from './leftpanel/foreign-key-constraints/foreign-key-constraints.component';
import {ViewForeignKeyConstraintComponent} from './leftpanel/foreign-key-constraints/foreign-key-constraints.component';
import {AddEmailConfigurationComponent} from './settings/email-settings/email-settings.component';
import {IdleWatchComponent} from './app.component';
import {OverrideExistingAPIComponent} from './promotion/promotion.component';
import {SchedulerComponent} from './scheduler/scheduler.component';
import {ScheduleJobDialogComponent} from './leftpanel/leftpanel.component';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {ManageScheduledJobsComponent} from './manage-scheduled-jobs/manage-scheduled-jobs.component';
import {CronScheduleJobDialogComponent} from './scheduler/scheduler.component';
import {CronEditorModule} from 'cron-editor';
import {ScheduleEmailComponent} from './executeemailtemplate/executeemailtemplate.component';
import {DataCatalogueComponent} from './data-catalogue/data-catalogue.component';
import {ErDiagramComponent} from './data-catalogue/er-diagram/er-diagram.component';
import {SchemaComponent} from './data-catalogue/er-diagram/schema/schema.component';
import {DataService} from './data-catalogue/er-diagram/service/data.service';
import {JsPlumbService} from './data-catalogue/er-diagram/service/jsPlumb.service';
import {ModelComponent} from './data-catalogue/er-diagram/model/model.component';
import {DataCatalogueParentComponent} from './data-catalogue-parent/data-catalogue-parent.component';
import {LineageDataService} from './data-catalogue/lineage-path/lineage-service/data.service';
import {LineageJsPlumbService} from './data-catalogue/lineage-path/lineage-service/jsPlumb.service';
import {LineagePathComponent} from './data-catalogue/lineage-path/lineage-path.component';
import {LineageModelComponent} from './data-catalogue/lineage-path/lineage-model/lineage-model.component';
import {LineageSchemaComponent} from './data-catalogue/lineage-path/lineage-schema/lineage-schema.component';
import {DeployAsAPIComponent} from './data-catalogue/data-catalogue.component';
import {TestsuiteComponent} from './testsuite/testsuite.component';
import {TestcaseComponent} from './testcase/testcase.component';
import {PrestepsComponent} from './testsuite/presteps/presteps.component';
import {TeardownComponent} from './testsuite/teardown/teardown.component';
import {ReportComponent} from './testsuite/report/report.component';
import {FilterPipeModule} from 'ngx-filter-pipe';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CreateUserComponent} from './manage-users1/create-user-component/create-user.component';
import {UserVerificationComponent} from './manage-users1/user-verification/user-verification.component';
import {ManageUsers1Component} from './manage-users1/manage-users1.component';
import {ViewRoleExclusionsComponent} from './manage-users1/view-role-exclusions/view-role-exclusions.component';
import {AdminDashboardComponent} from './admin-dashboard/admin-dashboard.component';
import {RoleModelComponent} from './manage-roles/role-model/role-model.component';
import {RoleSchemaComponent} from './manage-roles/role-schema/role-schema.component';
import {RoleDataService} from './manage-roles/role-service/data.service';
import {RoleJsPlumbService} from './manage-roles/role-service/jsPlumb.service';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {GatewayConsumerComponent} from './gateway-consumer/gateway-consumer.component';
import {CreateCredentialDialogComponent} from './gateway-consumer/create-credential-dialog/create-credential-dialog.component';
import {VerifyCredentialsComponent} from './gateway-consumer/create-credential-dialog/create-credential-dialog.component';
import {DeletePermissionGroupDialogComponent} from './manage-roles/manage-roles.component';
import {ResetPasswordDialogComponent} from './manage-users1/reset-password-dialog/reset-password-dialog.component';
import {NewRoleDialogComponent} from './manage-roles/manage-roles.component';
import {UserModelComponent} from './user-management/user-model/user-model.component';
import {UserSchemaComponent} from './user-management/user-schema/user-schema.component';
import {UserDataService} from './user-management/role-service/data.service';
import {UserJsPlumbService} from './user-management/role-service/jsPlumb.service';
import {ConfirmExclusionsDialogComponent} from './manage-roles/manage-roles.component';
import {AssociateWithGroupComponent} from './gateway-consumer/create-credential-dialog/create-credential-dialog.component';
import {AddEnvironmentDialogComponent} from './manage-users1/add-environment/add-environment-dialog.component';
import {ManageUserGroupsComponent} from './manage-user-groups/manage-user-groups.component';
import {CreateUserGroupDialogComponent} from './manage-user-groups/create-user-group-dialog/create-user-group-dialog.component';
import {UsersListDialogComponent} from './user-management/user-management.component';
import {BulkscriptsComponent} from './bulkscripts/bulkscripts.component';
import {InsufficientPermissionsToAccessComponent} from './leftpanel/leftpanel.component';
import {ApiDependenciesComponent} from './api-dependencies/api-dependencies.component';
import {AddEnvironmentUserGroupComponent} from './manage-user-groups/manage-user-groups.component';
import {ExpandMenu} from './settings/environment-settings/environment-settings.component';
import {ConfirmDatabaseDialogComponent} from './deploymentplan/deploymentplan.component';
import {AddNewConnectionComponent} from './data-catalogue-parent/data-catalogue-parent.component';

const google_oauth_client_id = '161587995850-nsdgbd4ckdqvgq7dussp443vrlquho46';
import {GrantPermissionDialogComponent} from './leftpanel/leftpanel.component';
import {MoreQueryOptionsComponent} from './more-query-options/more-query-options.component';
import {TestExecutorComponent} from './testsuite/test-executor/test-executor.component';
import {AuthenticatorComponent} from './authenticator/authenticator.component';
import {ConfirmSwitchingComponent} from './header-ribbon/header-ribbon.component';
import {CreateGatewayResourceConfirmationComponent} from './manage-entities/manage-entities.component';
import {ModeOfAccessConfirmationComponent} from './manage-entities/manage-entities.component';
import {ConfirmTestcaseDeletionComponent} from './testsuite/testsuite.component';
import {ApiRegisterComponent} from './api-register/api-register.component';

import {GuidedTourModule, GuidedTourService} from 'ngx-guided-tour';
import {HeaderRibbonComponent} from './header-ribbon/header-ribbon.component';
import {WebsocketService} from './websocket.service';
import {CodeIntegrationsComponent} from './code-integrations/code-integrations.component';
import {ProgressLogsComponent} from './progress-logs/progress-logs.component';
import {MenuListComponent} from './menu-list/menu-list.component';
import {LearnComponent} from './learn/learn.component';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {ConfirmResetAPIRegisterComponent} from './api-register/api-register.component';
import {EditBlocklyComponent} from './edit-blockly/edit-blockly.component';
import {DeploymentPlanMenuComponent} from './deploymentplan/deployment-plan-menu/deployment-plan-menu.component';
import {APIPoliciesComponent} from './leftpanel/leftpanel.component';
import {OAuth2ToggleConfirmationComponent} from './leftpanel/leftpanel.component';
import {ToggleJobStatusComponent} from './manage-scheduled-jobs/manage-scheduled-jobs.component';
import {ViewRawComponent} from './leftpanel/leftpanel.component';
import {ApiDependencyMenuComponent} from './api-dependencies/api-dependency-menu/api-dependency-menu.component';
import {DeployApiComponent} from './deploy-api/deploy-api.component';
import {DatadogMetricsComponent} from './leftpanel/leftpanel.component';
import {MonitoringModule} from './monitoring/monitoring.module';
import {PromoteToEnvironmentComponent} from './leftpanel/leftpanel.component';
import {TestReportComponent} from './testsuite/test-report/test-report.component';
import {ImportBpmnDialogComponent} from './bpmn/import-bpmn-dialog/import-bpmn-dialog.component';
import {AddAPIBlockComponent} from './new-blockly/new-blockly.component';
import {RequestBlockComponent} from './new-blockly/new-blockly.component';
import {JourneyAnalyticsComponent} from './journey-analytics/journey-analytics.component';
import {JourneyDashboardComponent} from './journey-analytics/journey-dashboard/journey-dashboard.component';
import {ApiDiscoveryComponent} from './api-discovery/api-discovery.component';
import {DependencyComponent} from './api-discovery/dependency/dependency.component';
import {UsagesComponent} from './api-discovery/usages/usages.component';
import {EntityComponent} from './api-discovery/entity/entity.component';
import {DiscoverExecutorComponent} from './api-discovery/discover-executor/discover-executor.component';
import {TestResultsComponent} from './testsuite/test-results/test-results.component';
import {JourneySessionDashboardComponent} from './journey-analytics/journey-session-dashboard/journey-session-dashboard.component';
import {ExportBpmnToS3Component} from './bpmn/workfloweditor/workfloweditor.component';
import {ImportFromS3Component} from './bpmn/workfloweditor/workfloweditor.component';
import {PromotionSettingsComponent} from './api-dependencies/promotion-settings/promotion-settings.component';
import {CompleteUserTaskDialogComponent} from './bpmn/process-instance/process-instance.component';
import {PlSqlBaseComponent} from './pl-sql-base/pl-sql-base.component';
import {DeveloperExperienceComponent} from './developer-experience/developer-experience.component';
import {AddPageComponent} from './docs/docs.component';
import {ImportFileDialogComponent} from './createfromopenapi/import-file-dialog/import-file-dialog.component';
import {
    AuthorizationTypesComponent,
    AuthTypesSaveConfirmationComponent
} from './settings/authorization-types/authorization-types.component';
import {ColorPickerModule} from 'ngx-color-picker';
import {DynamicFormBuilderComponent} from './settings/dynamic-form-builder/dynamic-form-builder.component';
import {DeveloperExperienceSettingsComponent} from './settings/developer-experience-settings/developer-experience-settings.component';
import {ApprovalFormComponent} from './settings/developer-experience-settings/approval-form/approval-form.component';
import {DevexSignupComponent} from './settings/developer-experience-settings/devex-signup/devex-signup.component';
import {DynamicJSONSampleDataComponent, MockResponseComponent} from './devex/mock-response/mock-response.component';
import {ResponseHeadersComponent} from './devex/response-headers/response-headers.component';
import {DocumentationComponent} from './documentation/documentation.component';
import {PlatformConsoleComponent} from './settings/platform-console/platform-console.component';
import {DevexConfigsComponent} from './settings/developer-experience-settings/devex-configs/devex-configs.component';
import {AddDevexConfigurationComponent} from './settings/developer-experience-settings/devex-configs/devex-configs.component';
import {FileStorageConfigsComponent} from './settings/file-storage-configs/file-storage-configs.component';
import {AddFileStorageConfigurationComponent} from './settings/file-storage-configs/file-storage-configs.component';
import {S3ConnectorsConfigsComponent} from './settings/s3-connectors-configs/s3-connectors-configs.component';
import {AddS3ConnectorConfigurationComponent} from './settings/s3-connectors-configs/s3-connectors-configs.component';
import {ApiqlEngineComponent} from './apiql-engine/apiql-engine.component';
import {DataqlEngineComponent} from './dataql-engine/dataql-engine.component';
import {PostmanCollectionsComponent} from './postman-collections/postman-collections.component';
import {JwtParserService} from './jwt-parser.service';
import {ManageAutomationComponent} from './manage-automation/manage-automation.component';
import {SourceCodeManagementSettingsComponent} from './manage-automation/source-code-management-settings/source-code-management-settings.component';
import {AutomationReportComponent} from './testsuite/automation-report/automation-report.component';
import {BuildReportComponent} from './testsuite/automation-report/build-report/build-report.component';
import {ImageViewerComponent} from './image-viewer/image-viewer.component';
import {TestResultsDashboardComponent} from './testsuite/test-results-dashboard/automation-dashboard.component';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {BlocklyEditorComponent} from './blockly-editor/blockly-editor.component';
import {AngularResizedEventModule} from 'angular-resize-event';
import {ReadOnlyComponent} from './new-blockly/read-only/read-only.component';
import {ConfigurationComponent} from './devex/configuration/configuration.component';
import {CookiesComponent} from './devex/cookies/cookies.component';
import {CookieService} from 'ngx-cookie-service';
import {ApiUsagesViewerComponent} from './api-usages-viewer/api-usages-viewer.component';
import {ApiTestsuiteEditorComponent} from './api-testsuite-editor/api-testsuite-editor.component';
import {GithubConnectionComponent} from './manage-entities/manage-entities.component';
import {BlockCodeEditorComponent} from './new-blockly/block-code-editor/block-code-editor.component';
import {GithubConnectionBusinessComponent} from './new-blockly/new-blockly.component';
import {GithubConnectionSqlComponent} from './business-logic-api-list/business-logic-api-list.component';
import {CollectionComponent, ImportCollectionLinkComponent, RunCollectionComponent} from './collection/collection.component';
import {AddApiGatewayComponent} from './settings/api-gateway-settings/add-api-gateway/add-api-gateway.component';
import {DashboardMetricsComponent} from './dashboard-metrics/dashboard-metrics.component';
import {SafePipe} from './monitoring/safe.pipe';
import {HelpComponent} from './help/help.component';
import {DeploymentSummaryComponent} from './deploymentplan/deployment-summary/deployment-summary.component';
import { SignupProgressComponent } from './signup/signup-progress/signup-progress.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {ViewMore} from './filter.pipe';
import { AcceleratorsComponent } from './accelerators/accelerators.component';
import { ImportVariablesComponent } from './accelerators/import-variables/import-variables.component';
import {ManageAcceleratorComponent, ManageAcceleratorsComponent} from './accelerators/manage-accelerator/manage-accelerator.component';
import { ViewAcceleratorCategoryComponent } from './accelerators/view-accelerator-category/view-accelerator-category.component';
import { DescriptionEditorComponent } from './description-editor/description-editor.component';
import { AlertSettingsComponent } from './alert-settings/alert-settings.component';
import {AlertDatabaseInputComponent, CreateAlertComponent} from './alert-settings/create-alert/create-alert.component';
import { SpinnerComponent } from './utils/spinner/spinner.component';
import { MonitoringDashboardComponent } from './monitoring-dashboard/monitoring-dashboard.component';
import { ConsoleComponent } from './console/console.component';
import { ImportOpeanapiFileComponent } from './createfromopenapi/import-opeanapi-file/import-opeanapi-file.component';
import { TransformationPlanComponent } from './transformation-plan/transformation-plan.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { TriggerComponent } from './trigger/trigger.component';
import { ManageTriggerComponent } from './manage-trigger/manage-trigger.component';
import { ApiBlockAdvancedSettingsComponent } from './new-blockly/api-block-advanced-settings/api-block-advanced-settings.component';
import { SignupConfigurationsComponent } from './signup/signup-configurations/signup-configurations.component';
import { CloudConfigsComponent } from './signup/signup-configurations/cloud-configs/cloud-configs.component';
import { OnboardPartnerComponent } from './signup/onboard-partner/onboard-partner.component';
import { DataViewerComponent } from './api-joins/data-viewer/data-viewer.component';
import { ApiJoinsAdditionalSettingsComponent } from './query-builder/api-joins-additional-settings/api-joins-additional-settings.component';
import { ApprovalPageComponent } from './query-builder/approval-page/approval-page.component';
import { DataEditComponent } from './api-joins/data-viewer/data-edit/data-edit.component';
import { LeftpanelNewComponent } from './leftpanel-new/leftpanel-new.component';
import { AddUserEnvironmentComponent } from './admin/manage-users/add-user-environment/add-user-environment.component';
import { AddUserEmailConfigComponent } from './admin/manage-users/add-user-email-config/add-user-email-config.component';
import { ManageUsersComponent } from './admin/manage-users/manage-users.component';
import { PlatformConsoleNewComponent } from './admin/platform-console-new/platform-console-new.component';
import {LanguageCommandsComponent} from './devex/api1/language-commands/language-commands.component';
import {CodeViewerComponent} from './devex/api1/language-commands/ace-editor/code-viewer.component';
import {ParameterDocsComponent} from './devex/api1/api1-executor/parameter-docs/parameter-docs.component';
import {ResponseBodyComponent} from './devex/api1/api1-executor/response-body/response-body.component';
import {SampleResponsesComponent} from './devex/api1/api1-executor/sample-responses/sample-responses.component';
import { ShowJobLogsComponent } from './manage-scheduled-jobs/show-job-logs/show-job-logs.component';
import { ManageUserGroupsNewComponent } from './admin/manage-user-groups-new/manage-user-groups-new.component';
import { AddUserGroupComponentComponent } from './admin/manage-user-groups-new/add-user-group-component/add-user-group-component.component';
import { AddUserGroupEnvironmentComponentComponent } from './admin/manage-user-groups-new/add-user-group-environment-component/add-user-group-environment-component.component';
import {DeveloperSettingsNewComponent} from './admin/developer-settings-new/developer-settings-new.component';
import {
    AddDevexConfigurationNewComponent
} from './admin/developer-settings-new/add-devex-configuration-new/add-devex-configuration-new.component';
import {FileStorageNewComponent} from './admin/file-storage-new/file-storage-new.component';
import {AddFileStorageConfigNewComponent} from './admin/file-storage-new/add-file-storage-config-new/add-file-storage-config-new.component';
import { AdminConsumersComponent } from './admin/admin-consumers/admin-consumers.component';
import {ApiGatewaySettingsNewComponent} from './admin/api-gateway-settings-new/api-gateway-settings-new.component';
import {AddApiGatewayNewComponent} from './admin/api-gateway-settings-new/add-api-gateway-new/add-api-gateway-new.component';
import {AddNewGatewayNewComponent} from './admin/api-gateway-settings-new/add-new-gateway-new/add-new-gateway-new.component';
import {DatabasesNewComponent} from './admin/databases-new/databases-new.component';

import {S3ConnectorsNewComponent} from './admin/s3-connectors-new/s3-connectors-new.component';
import {
    AddS3ConnectorsConfigNewComponent
} from './admin/s3-connectors-new/add-s3-connectors-config-new/add-s3-connectors-config-new.component';
import {EmailSettingsNewComponent} from './admin/email-settings-new/email-settings-new.component';
import {
    AddEmailConfigurationNewComponent
} from './admin/email-settings-new/add-email-configuration-new/add-email-configuration-new.component';
import {AuthorizationTypesNewComponent} from './admin/authorization-types-new/authorization-types-new.component';
import {
    AuthTypesSaveConfirmationNewComponent
} from './admin/authorization-types-new/auth-types-save-confirmation-new/auth-types-save-confirmation-new.component';
import {EnvironmentsNewComponent} from './admin/environments-new/environments-new.component';

import { CreateConsumerDialogComponent } from './admin/admin-consumers/create-consumer-dialog/create-consumer-dialog.component';
import { AdminGatewaySettingsComponent } from './admin/admin-gateway-settings/admin-gateway-settings.component';
import {
    AddPlatformConsoleConfigurationNewComponent
} from './admin/platform-console-new/add-platform-console-configuration-new/add-platform-console-configuration-new.component';
import {IdleTimeoutNewComponent} from './idle-timeout-new/idle-timeout-new.component';
import {IdleTimeoutComponent} from './settings/idle-timeout/idle-timeout.component';
import {AddPlatformConsoleConfigurationComponent} from './settings/platform-console/platform-console.component';
import { ViewExclusionsDialogComponent } from './admin/view-exclusions-dialog/view-exclusions-dialog.component';
import {NgxPayPalModule} from 'ngx-paypal';
import { BodyParamsDescriptionComponent } from './devex/headers/body-params-description/body-params-description.component';
import { RawBodyDescriptionComponent } from './devex/api1/api1-executor/raw-body-description/raw-body-description.component';
import { BillingCreditsComponent, RedeemCreditDialog } from './billing/billing-credits/billing-credits.component';
import { BillingInvoicesComponent } from './billing/billing-invoices/billing-invoices.component';
import { BillingPaymentsComponent } from './billing/billing-payments/billing-payments.component';
import { CognitiveSearchComponent } from './cognitive-search/cognitive-search.component';
import { CognitiveSearchNewComponent } from './cognitive-search-new/cognitive-search-new.component';
import { DatasourceComponent } from './datasource/datasource.component';
import { AddDataSourceComponent } from './datasource/add-data-source/add-data-source.component';
import { DataAnalyticsComponent } from './data-analytics/data-analytics.component';
import { DataAnalyticsNewComponent } from './data-analytics-new/data-analytics-new.component';
import { DataTransformationComponent, DataTransformationTestResultDialog } from './data-transformation/data-transformation.component';
import { CalculatedFieldDialog, DataTransformationPlanComponent, DynamicFieldDialog } from './data-transformation-plan/data-transformation-plan.component';
import {DataTransformationResultComponent, ViewResponseLogDialog} from './data-transformation-result/data-transformation-result.component';
import { DataTransformationHistoryComponent } from './data-transformation-history/data-transformation-history.component';
import { DataTransformationListComponent } from './data-transformation-list/data-transformation-list.component';
import { DataTransformationMetricComponent } from './data-transformation-result/data-transformation-metric/data-transformation-metric.component';



const config = new AuthServiceConfig([
    {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(google_oauth_client_id)
    }
]);


@NgModule({
    declarations: [
        AppComponent,
        AddEnvComponent,
        ChatComponent,
        FilterPipe,
        FilterPipe1,
        OrderByPipe,
        FilterByObject,
        SearchFile,
        SearchByObject,
        FilterByQuery,
        FilterByName,
        ViewMore,
        LoginComponent,
        HeaderComponent,
        IdleTimeoutComponent,
        SupportHeaderComponent,
        FooterComponent,
        LeftpanelComponent,
        ApiComponent,
        AddComponent,
        EditComponent,
        ConfirmReplaceRecordComponent,
        CustomOperationEditComponent,
        InfoComponent,
        ImportComponent,
        CrudapiComponent,
        AddSecretComponent,
        AddNewPermissionComponent,
        AttributeDescriptionComponent,
        LoginpanelComponent,
        SignupComponent,
        PartnerOnboardComponent,
        HomeOldComponent,
        DialogComponent,
        PlansComponent,
        Feedback1Component,
        ManageEntitiesComponent,
        SignUpComponent,
        EditEntityComponent,
        DialogOverviewExampleDialogComponent,
        CreateDatabaseComponent,
        EndpointComponent,
        AddNewCloudComponent,
        MetricsComponent,
        FeedbackComponent,
        ContactSalesComponent,
        LegalComponent,
        FaqComponent,
        FileStoreComponent,
        ResetPasswordComponent,
        LegalDocsComponent,
        QueryBuilderComponent,
        CustomoperationComponent,
        EditorComponent,
        CommonDataApiComponent,
        MetricsDashboardComponent,
        DigitalTransformerComponent,
        DevexComponent,
        AddNewGatewayComponent,
        ApimanagementComponent,
        ManageRolesComponent,
        PermissionGroupsComponent,
        UserManagementComponent,
        FabricatorComponent,
        ResponseMapComponent,
        ResourceJsonEditorComponent,
        RuleSetComponent,
        ApiExecutorComponent,
        HeadersComponent,
        TestComponent,
        UniqueComponent,
        CreatefromopenapiComponent,
        DeleteConfirmationComponent,
        PublishServiceConfirmationComponent,
        ActivateServiceConfirmationComponent,
        SecureApiConfirmationComponent,
        PromotionConfirmationComponent,
        SubArrayComponent,
        NewBlocklyComponent,
        DeploymentplanComponent,
        DatabaseviewerComponent,
        ExecutorComponent,
        SwifterComponent,
        AuthorizationComponent,
        ShowProgressComponent,
        ShowResultsComponent,
        DeployAsApiComponent,
        BusinessLogicApiListComponent,
        InlineEditComponent,
        DashboardContainerComponent,
        AuthContainerComponent,
        SupportComponent,
        DialogProgressComponent,
        DialogSuccessComponent,
        DialogErrorComponent,
        SimpleApiListComponent,
        BillingComponent,
        SimpleApiListComponent,
        GatewayComponent,
        BasicAuthComponent,
        KeyAuthComponent,
        OAuth2Component,
        HmacAuthComponent,
        JwtComponent,
        LdapAuthComponent,
        AclComponent,
        CorsComponent,
        IPRestrictionComponent,
        BotDetectionComponent,
        RateLimitingComponent,
        ResponseRateLimitingComponent,
        RequestSizeLimitingComponent,
        RequestTerminationComponent,
        AwsLambdaComponent,
        PreFunctionComponent,
        PostFunctionComponent,
        AzureFunctionComponent,
        DataDogComponent,
        PrometheusComponent,
        ZipkinComponent,
        AuthenticationComponent,
        PopUpComponent,
        MasterPluginComponent,
        TooGoodToBelieveComponent,
        ApplyToRouteComponent,
        ConfigureInRouteComponent,
        ImageUploadComponent,
        SubQueryBuilderComponent,
        DragDropDirective,
        AttributesListComponent,
        ConfirmationWithoutResponseAttributesComponent,
        SettingsComponent,
        SettingsTopComponent,
        BusinessdetailsComponent,
        BusinesslocationsComponent,
        CreditsComponent,
        DatabasesComponent,
        IdentitymanagerComponent,
        IpconfigComponent,
        BrandingComponent,
        AccountsComponent,
        filterNames,
        filterNames1,
        filterByName,
        QueryBuilderBaseComponent,
        ResumeParserComponent,
        BpmnComponent,
        WorkfloweditorComponent,
        CamundaviewerComponent,
        VariablesDialog,
        ProcessInstanceComponent,
        EmailtemplatebuilderComponent,
        ExecuteemailtemplateComponent,
        DifferentiateParametersComponent,
        EditConfirmationComponent,
        SelectAPIComponent,
        CreateDatabaseDuringSignUpComponent,
        EditDatabaseDuringSignUpComponent,
        Api1ExecutorComponent,
        DmnComponent,
        CampaignManagerComponent,
        ApiNewComponent,
        ViewDialogComponent,
        AddDialogComponent,
        AddVaultComponent,
        AddToCollComponent,
        DeleteDialogComponent,
        EditDialogComponent,
        AddCatComponent,
        AddProdComponent,
        CampaignManagerComponent,
        ConnectorComponent,
        CreatorComponent,
        EnablerComponent,
        DetailComponent,
        GetStartedComponent,
        VideoDialogComponent,
        LandingPageComponent,
        TransformerComponent,
        ViewerComponent,
        FormCmpComponent,
        EditCmpComponent,
        ApiKeyComponent,
        DashboardComponent,
        MetricsSettingsComponent,
        AudienceSettingsComponent,
        AuthorizationsSettingsComponent,
        CampaignSettingsComponent,
        ComplianceSettingsComponent,
        ConnectorsSettingsComponent,
        CouponManagementSettingsComponent,
        EncryptionSettingsComponent,
        PermissionGroupSettingsComponent,
        RolesSettingsComponent,
        SourceControlManagementSettingsComponent,
        UserGroupsSettingsComponent,
        UsersSettingsComponent,
        ApiRegistrarSettingsComponent,
        BotSettingsComponent,
        CodeGenSettingsComponent,
        GrRateLimitingSettingsComponent,
        GtIpSettingsComponent,
        IntegrationLanguagesSettingsComponent,
        IntegratorSettingsComponent,
        ServiceProvidersSettingsComponent,
        ServicesSettingsComponent,
        SubscriptionSettingsComponent,
        ThemesSettingsComponent,
        TransformationApiSettingsComponent,
        TransformationCobolSettingsComponent,
        TransformationDatabaseSettingsComponent,
        DevexSettingsComponent,
        SecuritySettingsComponent,
        BillingSettingsComponent,
        CloudPlatformSettingsComponent,
        EnvironmentSettingsComponent,
        ApiGatewaySettingsComponent,
        DatabaseInfSettingsComponent,
        LoggingSettingsComponent,
        FileSettingsComponent,
        IdentitySettingsComponent,
        TrafficSettingsComponent,
        AddCmpComponent,
        CloudInfrastructureComponent,
        ComputerNetworksComponent,
        DatabaseComponent,
        DetailCdaComponent,
        EducationComponent,
        GeoComponent,
        LocalesComponent,
        TalentManagementComponent,
        GtCorsSettingsComponent,
        EmailSettingsComponent,
        PermissionSettingsComponent,
        IntegrationsComponent,
        ConnectorsComponent,
        GetConnectorConfigurationsComponent,
        GetPasswordComponent,
        ShowCredentialsComponent,
        AddServiceProviderComponent,
        AddNewAuthorizationConfigurationComponent,
        CategoriesComponent,
        CategoryComponent,
        ProviderCategoryComponent,
        AddServiceProviderCategoryComponent,
        DocumentorComponent,
        DocComponent,
        DocsComponent,
        EditDocsComponent,
        DocseditorComponent,
        CollectionsComponent,
        PasswordManagerComponent,
        ManageemailtemplatesComponent,
        EntityVersionChangeConfirmationComponent,
        CloudInfraManagerComponent,
        EnvironmentManagerComponent,
        ApigatewayManagerComponent,
        DevExServiceManagerComponent,
        DatabaseManagerComponent,
        EnvironmentCreatorComponent,
        AddEnvironmentComponent,
        AddEnvironmentDialogComponent,
        EnvironmentCreatorComponent,
        CobolToApiComponent,
        SamplesComponent,
        ResultsViewerComponent,
        UxbuilderComponent,
        PromotionComponent,
        ApimenupanelComponent,
        MatVerticalStepperScrollerDirective,
        ClickOutsideDirective,
        JsontoapiComponent,
        ApitoapiComponent,
        ConnectorlistComponent,
        EnvironmentCreationComponent,
        FeedbackComponent,
        NotFoundComponent,
        ConfigurationsComponent,
        AuditLogsComponent,
        SnackbarComponent,
        filterCard,
        filterCard,
        filterCard,
        filterCardByName,
        filterCollection,
        SwitchEnvironmentComponent,
        DaasCreatorComponent,
        ApiManagerComponent,
        DataaccessapiComponent,
        EndPointsComponent,
        LoaderWithProgressComponent,
        AddGatewayResourceComponent,
        UseExistingTableConfirmationComponent,
        ApiResponseSettingsComponent,
        ApiCacheSettingsComponent,
        CrudapiAdvancedComponent,
        EditEntityAdvancedComponent,
        TestsuiteComponent,
        TestcaseComponent,
        CopyToPartnerComponent,
        ForeignKeyConstraintsComponent,
        AddForeignKeyConstraintComponent,
        ViewForeignKeyConstraintComponent,
        AddEmailConfigurationComponent,
        IdleWatchComponent,

        IdleTimeoutNewComponent,
        OverrideExistingAPIComponent,
        SchedulerComponent,
        ScheduleJobDialogComponent,
        ManageScheduledJobsComponent,
        CronScheduleJobDialogComponent,
        ScheduleEmailComponent,
        DataCatalogueComponent,
        ErDiagramComponent,
        SchemaComponent,
        ModelComponent,
        DataCatalogueParentComponent,
        DataCatalogueComponent,
        CreateFolderDialog,
        UploadFileDialog,
        UploadFolderDialog,
        LineagePathComponent,
        LineageModelComponent,
        LineageSchemaComponent,
        DeployAsAPIComponent,
        ApiBrowserComponent,
        TestCaseNameInputDialog,
        PrestepsComponent,
        TeardownComponent,
        ReportComponent,
        GatewayConsumerComponent,
        CreateCredentialDialogComponent,
        AdminDashboardComponent,
        VerifyCredentialsComponent,
        CreateUserComponent,
        UserVerificationComponent,
        ManageUsers1Component,
        ViewRoleExclusionsComponent,
        RoleModelComponent,
        RoleSchemaComponent,
        VerifyCredentialsComponent,
        DeletePermissionGroupDialogComponent,
        NewRoleDialogComponent,
        UserModelComponent,
        UserSchemaComponent,
        ResetPasswordDialogComponent,
        ConfirmExclusionsDialogComponent,
        AssociateWithGroupComponent,
        ManageUserGroupsComponent,
        CreateUserGroupDialogComponent,
        UsersListDialogComponent,
        BulkscriptsComponent,
        InsufficientPermissionsToAccessComponent,
        ApiDependenciesComponent,
        GrantPermissionDialogComponent,
        AddEnvironmentUserGroupComponent,
        MoreQueryOptionsComponent,
        TestExecutorComponent,
        AuthenticatorComponent,
        ConfirmSwitchingComponent,
        ConfirmTestcaseDeletionComponent,
        CreateGatewayResourceConfirmationComponent,
        ModeOfAccessConfirmationComponent,
        ApiRegisterComponent,
        ExpandMenu,
        HeaderRibbonComponent,
        CodeIntegrationsComponent,
        ProgressLogsComponent,
        HeaderRibbonComponent,
        MenuListComponent,
        LearnComponent,
        ConfirmResetAPIRegisterComponent,
        EditBlocklyComponent,
        DeploymentPlanMenuComponent,
        APIPoliciesComponent,
        OAuth2ToggleConfirmationComponent,
        ToggleJobStatusComponent,
        ViewRawComponent,
        ApiDependencyMenuComponent,
        DeployApiComponent,
        PromoteToEnvironmentComponent,
        InjectLogsDirective,
        ConfirmDatabaseDialogComponent,
        DatadogMetricsComponent,
        TestReportComponent,
        ImportBpmnDialogComponent,
        AddAPIBlockComponent,
        RequestBlockComponent,
        JourneyAnalyticsComponent,
        JourneyDashboardComponent,
        ApiDiscoveryComponent,
        DependencyComponent,
        UsagesComponent,
        EntityComponent,
        DiscoverExecutorComponent,
        TestResultsComponent,
        ExportBpmnToS3Component,
        ImportFromS3Component,
        JourneySessionDashboardComponent,
        PlSqlBaseComponent,
        ImportFileDialogComponent,
        PromotionSettingsComponent,
        CompleteUserTaskDialogComponent,
        AddPageComponent,
        DeveloperExperienceComponent,
        ApplicationDeleteConfirmationComponent,
        ApplicationVersionChangeConfirmationComponent,
        AuthorizationTypesComponent,
        AuthTypesSaveConfirmationComponent,
        PageVersionChangeConfirmationComponent,
        DynamicFormBuilderComponent,
        DeveloperExperienceSettingsComponent,
        ApprovalFormComponent,
        DevexSignupComponent,
        MockResponseComponent,
        NewMockResponseEntryInputComponent,
        ReplaceMockDataConfirmationComponent,
        ResponseHeadersComponent,
        ResponseSettingsComponent,
        DynamicJSONSampleDataComponent,
        DocumentationComponent,
        PlatformConsoleComponent,
        AddPlatformConsoleConfigurationNewComponent,
        AddPlatformConsoleConfigurationComponent,
        DevexConfigsComponent,
        AddFileStorageConfigNewComponent,
        AddDevexConfigurationComponent,
        FileStorageConfigsComponent,
        AddFileStorageConfigurationComponent,
        S3ConnectorsConfigsComponent,
        AddS3ConnectorConfigurationComponent,
        ApiqlEngineComponent,
        DataqlEngineComponent,
        PostmanCollectionsComponent,
        DefaultApiUrlComponent,
        ManageAutomationComponent,
        SourceCodeManagementSettingsComponent,
        AutomationReportComponent,
        BuildReportComponent,
        TestResultsDashboardComponent,
        ImageViewerComponent,
        BlocklyEditorComponent,
        ReadOnlyComponent,
        ConfigurationComponent,
        CookiesComponent,
        ApiUsagesViewerComponent,
        DependencyCheckComponent,
        CoreCheckComponent,
        ApiTestsuiteEditorComponent,
        GithubConnectionComponent,
        BlockCodeEditorComponent,
        GithubConnectionBusinessComponent,
        GithubConnectionSqlComponent,
        CollectionComponent,
        ImportCollectionLinkComponent,
        RunCollectionComponent,
        AddApiGatewayComponent,
        YouTubeURLFilter,
        AddAttributeComponent,
        CreateApiComponent,
        AddNewConnectionComponent,
        DashboardMetricsComponent,
        SafePipe,
        HelpComponent,
        DeploymentSummaryComponent,
        SignupProgressComponent,
        AcceleratorsComponent,
        ImportVariablesComponent,
        ManageAcceleratorComponent,
        ViewAcceleratorCategoryComponent,
        ManageAcceleratorsComponent,
        DescriptionEditorComponent,
        BlocklyAddButtonsComponent,
        AlertSettingsComponent,
        CreateAlertComponent,
        SpinnerComponent,
        AlertDatabaseInputComponent,
        MonitoringDashboardComponent,
        ConsoleComponent,
        ImportOpeanapiFileComponent,
        urlYouTubeFilter,
        urlDataAnalyticsFilter,
        FilterExecutorsPipe,
        TransformationPlanComponent,
        TriggerComponent,
        ManageTriggerComponent,
        ApiBlockAdvancedSettingsComponent,
        SignupConfigurationsComponent,
        CloudConfigsComponent,
        OnboardPartnerComponent,
        DataViewerComponent,
        ApiJoinsAdditionalSettingsComponent,
        ApprovalPageComponent,
        DataEditComponent,
        ManageUsersComponent,
        LeftpanelNewComponent,
        AddUserEnvironmentComponent,
        AddUserEmailConfigComponent,
        PlatformConsoleNewComponent,
        LanguageCommandsComponent,
        CodeViewerComponent,
        ParameterDocsComponent,
        ResponseBodyComponent,
        SampleResponsesComponent,
        ShowJobLogsComponent,
        SampleResponsesComponent,
        ManageUserGroupsNewComponent,
        AddUserGroupComponentComponent,
        AddUserGroupEnvironmentComponentComponent,
        SampleResponsesComponent,
        DeveloperSettingsNewComponent,
        AddDevexConfigurationNewComponent,
        FileStorageNewComponent,
        AdminConsumersComponent,
        ApiGatewaySettingsNewComponent,
        AddApiGatewayNewComponent,
        AddNewGatewayNewComponent,
        DatabasesNewComponent,

        S3ConnectorsNewComponent,
        AddS3ConnectorsConfigNewComponent,
        EmailSettingsNewComponent,
        AddEmailConfigurationNewComponent,
        AuthorizationTypesNewComponent,
        AuthTypesSaveConfirmationNewComponent,
        EnvironmentsNewComponent,
        CreateConsumerDialogComponent,
        AdminGatewaySettingsComponent,
        AddPlatformConsoleConfigurationNewComponent,
        AddPlatformConsoleConfigurationComponent,
        ViewExclusionsDialogComponent,
        ChoosePaymentDialog,
        PaymentConfirmationDialog,
        BillingWarningDialog,
        BodyParamsDescriptionComponent,
        RawBodyDescriptionComponent,
        BillingCreditsComponent,
        RedeemCreditDialog,
        BillingInvoicesComponent,
        BillingPaymentsComponent,
        CognitiveSearchComponent,
        CognitiveSearchNewComponent,
        DatasourceComponent,
        AddDataSourceComponent,
        DataAnalyticsComponent,
        DataAnalyticsNewComponent,
        DataTransformationComponent,
        DataTransformationPlanComponent,
        CalculatedFieldDialog,
        DataTransformationTestResultDialog,
        DynamicFieldDialog,
        DataTransformationResultComponent,
        DataTransformationHistoryComponent,
        DataTransformationListComponent,
        DataTransformationMetricComponent,
        ViewResponseLogDialog


    ],
    imports: [
        routing,
        AngularResizedEventModule,
        BrowserModule,
        CommonModule,
        OrgChartModule,
        FormsModule,
        NgJsonEditorModule,
        ReactiveFormsModule,
        TreeModule,
        TreeviewModule.forRoot(),
        HttpModule,
        HttpClientModule,
        MatInputModule,
        MatExpansionModule,
        BrowserAnimationsModule,
        DataTableModule,
        //NG2DataTableModule,
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        AngularMultiSelectModule,
        MatSnackBarModule,
        MatDialogModule,
        MatTreeModule,
        MatButtonModule, MatCheckboxModule,
        MatTooltipModule, MatCardModule,
        MatAutocompleteModule, MatRadioModule,
        MatIconModule, MatExpansionModule,
        MatStepperModule,
        MatButtonToggleModule,
        MatProgressBarModule,
        Angular2CsvModule,
        MatGridListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        QueryBuilderModule,
        // SocialLoginModule.initialize(config),
        ChartsModule,
        MatListModule,
        MonacoEditorModule.forRoot(), MatSlideToggleModule,
        AngularEditorModule,
        FooterModule,
        CommonContainerModule,
        FlexLayoutModule,
        MatIconModule,
        MaterialModule,
        WidgetLineAnimModule,
        TbScrollVisibilityModule,
        MatMenuModule,
        TbScrollSingleActiveModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        RecaptchaModule.forRoot(),
        NgBpmnEditorModule,
        Ng2SearchPipeModule,
        AceEditorModule,
        NgIdleKeepaliveModule.forRoot(),
        ModalModule.forRoot(),
        CronEditorModule,
        FilterPipeModule,
        NgbPaginationModule,
        DragDropModule,
        NgMaterialMultilevelMenuModule,
        GuidedTourModule,
        YouTubePlayerModule,
        MonitoringModule,
        ColorPickerModule,
        ScrollingModule,
        NgxDaterangepickerMd.forRoot(),
        IvyCarouselModule,
        NgxMatSelectSearchModule,
        MatToolbarModule,
        NgxPayPalModule
    ],
    exports: [
        MatIconModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        RecaptchaModule
    ],
    providers: [PlatformCentralAuth, ManageEntitiesComponent, AppComponent, BusinessLogicApiListComponent,
        Loggedin, CreatorComponent, NewBlocklyComponent, WorkfloweditorComponent, ProviderCategoryComponent,
        UniqueComponent, SettingsComponent, PartnerOnboardComponent, LeftpanelComponent, LeftpanelNewComponent, DatabaseManagerComponent, TestExecutorComponent, TestsuiteComponent,
        ConnecttocrudService, MatDatepickerModule, HttpClientModule, ResourceJsonEditorComponent, MasterPluginComponent, CrudapiComponent, SubArrayComponent, AttributesListComponent, DevexComponent, BpmnComponent, WorkfloweditorComponent, SignupComponent, CsvService, EnvironmentManagerComponent, LoginComponent, ApimanagementComponent, BasicAuthComponent, ApiRegistrarSettingsComponent, DataService, JsPlumbService, LineageDataService, LineageJsPlumbService, RoleDataService, RoleJsPlumbService, UserDataService, UserJsPlumbService, ManageEntitiesComponent,
        GuidedTourService, WebsocketService, ProgressLogsComponent, JwtParserService, CookieService, FooterComponent, DatabasesComponent, IntegrationsComponent],
    entryComponents: [DialogOverviewExampleDialogComponent, PopUpComponent, ConfirmReplaceRecordComponent, SnackbarComponent,
        ApplyToRouteComponent, ConfigureInRouteComponent, AddEnvComponent, AddNewGatewayComponent,
        EndpointComponent, SupportComponent, VideoDialogComponent, EntityVersionChangeConfirmationComponent,
        DialogProgressComponent, DialogSuccessComponent, AddVaultComponent, AddNewCloudComponent, AddNewPermissionComponent,
        DialogErrorComponent, DeployAsApiComponent, ViewDialogComponent, AddDialogComponent, EditDialogComponent, DeleteDialogComponent, AddCatComponent, AddProdComponent, AddToCollComponent,
        LegalComponent, AddSecretComponent, ChatComponent,
        FaqComponent, DeleteConfirmationComponent, PublishServiceConfirmationComponent, ActivateServiceConfirmationComponent,
        CreateDatabaseComponent, AttributeDescriptionComponent, PromotionConfirmationComponent,
        FeedbackComponent, MetricsComponent, DialogComponent, CreateFolderDialog, UploadFileDialog, UploadFolderDialog, CreateCredentialDialogComponent, CreateUserComponent, UserVerificationComponent, ViewRoleExclusionsComponent, ResetPasswordDialogComponent, AddEnvironmentDialogComponent, GrantPermissionDialogComponent, CreateUserGroupDialogComponent, AddEnvironmentUserGroupComponent,
        GetConnectorConfigurationsComponent, GetPasswordComponent, ShowCredentialsComponent, AddServiceProviderComponent, AddNewAuthorizationConfigurationComponent, AddServiceProviderCategoryComponent, EditDatabaseDuringSignUpComponent, CreateDatabaseDuringSignUpComponent, DifferentiateParametersComponent, EditConfirmationComponent, SwitchEnvironmentComponent, LoaderWithProgressComponent, AddGatewayResourceComponent, UseExistingTableConfirmationComponent, CopyToPartnerComponent, AddForeignKeyConstraintComponent, ViewForeignKeyConstraintComponent,
        AddEmailConfigurationComponent, IdleWatchComponent, OverrideExistingAPIComponent, ScheduleJobDialogComponent, CronScheduleJobDialogComponent, ScheduleEmailComponent, DeployAsAPIComponent, TestCaseNameInputDialog, ReportComponent, TestReportComponent, VerifyCredentialsComponent, DeletePermissionGroupDialogComponent, NewRoleDialogComponent, ConfirmExclusionsDialogComponent, AssociateWithGroupComponent, UsersListDialogComponent,
        PromoteToEnvironmentComponent, TestReportComponent, InsufficientPermissionsToAccessComponent, ConfirmSwitchingComponent, ConfirmTestcaseDeletionComponent, SecureApiConfirmationComponent, CreateGatewayResourceConfirmationComponent, ModeOfAccessConfirmationComponent, ConfirmationWithoutResponseAttributesComponent, ConfirmResetAPIRegisterComponent, APIPoliciesComponent, ConfirmDatabaseDialogComponent,
        OAuth2ToggleConfirmationComponent, ProgressLogsComponent, ImportBpmnDialogComponent, AddAPIBlockComponent, RequestBlockComponent,
        ToggleJobStatusComponent, ViewRawComponent, DatadogMetricsComponent, ExportBpmnToS3Component, ImportFromS3Component, PromotionSettingsComponent, CamundaviewerComponent, CompleteUserTaskDialogComponent, AddPageComponent, ApplicationDeleteConfirmationComponent, ApplicationVersionChangeConfirmationComponent, AuthTypesSaveConfirmationComponent, PageVersionChangeConfirmationComponent, ImportFileDialogComponent, NewMockResponseEntryInputComponent, ReplaceMockDataConfirmationComponent, ResponseSettingsComponent, AddPlatformConsoleConfigurationNewComponent,AddPlatformConsoleConfigurationComponent,AddDevexConfigurationComponent,AddFileStorageConfigNewComponent, BlockCodeEditorComponent,
        AddFileStorageConfigurationComponent, AddS3ConnectorConfigurationComponent, DefaultApiUrlComponent, ImageViewerComponent, DependencyCheckComponent, CoreCheckComponent, GithubConnectionComponent, GithubConnectionBusinessComponent, GithubConnectionSqlComponent, ImportCollectionLinkComponent, RunCollectionComponent, AddAttributeComponent, CreateApiComponent, AddApiGatewayComponent,
        DatabasesComponent, AddNewConnectionComponent, DeploymentSummaryComponent , ImportVariablesComponent, ManageAcceleratorComponent, ManageAcceleratorsComponent, DescriptionEditorComponent, BlocklyAddButtonsComponent, CreateAlertComponent, AlertDatabaseInputComponent, ApiBlockAdvancedSettingsComponent, CloudConfigsComponent, DataEditComponent, ShowJobLogsComponent, AddUserEnvironmentComponent,
        AddUserEmailConfigComponent, AddUserGroupComponentComponent, AddUserGroupEnvironmentComponentComponent, AddDevexConfigurationNewComponent,AddApiGatewayNewComponent, AddNewGatewayNewComponent,AddS3ConnectorsConfigNewComponent, AddEmailConfigurationNewComponent, AuthTypesSaveConfirmationNewComponent, CreateConsumerDialogComponent, ViewExclusionsDialogComponent,ChoosePaymentDialog, PaymentConfirmationDialog, RedeemCreditDialog, AddDataSourceComponent, CalculatedFieldDialog, DataTransformationTestResultDialog, DynamicFieldDialog,BillingWarningDialog,ViewResponseLogDialog
    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}

